<template>
<el-card class="h-full" :body-style="{ height: '100%' }">
    <el-row class="mb-10px" type="flex" align="middle">
        <span class="text-14px leading-36px mr-10px">数据标准库</span><selectStandardId @updateStandardId="updateStandardId" />
        <span class="text-14px leading-36px mr-10px ml-10px">文档编码</span>
        <el-input
            class="w-200px mr-10px"
            size="small"
            v-model="searchData.DocumentCode"
            placeholder="请输入文档编码"
            clearable
        ></el-input>
        <span class="text-14px leading-36px mr-10px ml-10px">文档名称</span>
        <el-input
            class="w-200px mr-10px"
            size="small"
            v-model="searchData.DocumentName"
            placeholder="请输入文档名称"
            clearable
        ></el-input>
        <span class="text-14px leading-36px mr-10px ml-10px">文档类别</span>
        <el-select
            v-model="searchData.ClassId"
            placeholder="请选择文档类别"
            class="w-200px mr-10px"
            size="small"
            collapse-tags
            filterable
            clearable
        >
            <el-option
            v-for="item in classTypeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            ></el-option>
        </el-select>
        <span class="text-14px leading-36px mr-10px ml-10px">文件名称</span>
        <el-input
            class="w-200px mr-10px"
            size="small"
            v-model="searchData.FileName"
            placeholder="请输入文件名称"
            clearable
        ></el-input>
        <el-button size="small" type="primary" :disabled="!$hasAccess('read')" @click="searchList">搜索</el-button>
        <el-button size="small" type="primary" :disabled="!$hasAccess('export')" v-loading="exportLoading" @click="exportData">导出</el-button>
    </el-row>
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      class="mt-20px"
      height="calc(100% - 104px)"
      border
      stripe
    >
        <el-table-column label="文档编码" prop="documentCode"></el-table-column>
        <el-table-column label="文档名称" prop="documentName"></el-table-column>
        <el-table-column label="文档类别" prop="className"></el-table-column>
        <el-table-column label="版本" prop="revision"></el-table-column>
        <el-table-column label="文件路径" prop="path"></el-table-column>
        <el-table-column label="文件名称" prop="fileName"></el-table-column>
        <el-table-column label="问题说明" prop="description"></el-table-column>
    </el-table>
    <el-pagination
      class="mt-20px text-right"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :page-sizes="$pageSizeAll"
      @current-change="getTableData"
      @size-change="searchList"
    >
    </el-pagination>
</el-card>

</template>
<script>
import dataValidationReportService from '@/services/dataValidationReportService'
import stdClassListService from '@/services/stdClassListService'
import fnMixin from '@/assets/js/fnMixins'
import selectStandardId from '../../components/selectStandardId'
export default {
    name: 'documentFile',
    components: {
        selectStandardId,
    },
    mixins: [fnMixin],
    data() {
        return {
            exportLoading: false,
            tableLoading: false,
            tableData: [],
            standardId: localStorage.getItem('standardId'),
            searchData: {
                DocumentCode: '',
                DocumentName: '',
                ClassId: '',
                FileName: ''
            },
            page: {
                pageNo: 1,
                pageSize: 15,
                total: 0,
            },
            classTypeList: []
        }
    },
    methods: {
        // 导出
        async exportData() {
            const params = {
                StandardId: this.standardId,
                skipCount: (this.page.pageNo - 1) * this.page.pageSize,
                maxResultCount: this.page.pageSize,
                ...this.searchData,
            }
            this.exportLoading = true
            const res = await dataValidationReportService.getDocumentFileReportExport(params)
            this.exportLoading = false
            if (res) {
                this.downLoadBlob({
                    name: '文档文件完整性校验报表导出结果.xlsx',
                    data: res
                })
            }
        },
        // 搜索列表
        searchList() {
            this.page.pageNo = 1
            this.getTableData()
        },
        async getTableData() {
            const params = {
                StandardId: this.standardId,
                skipCount: (this.page.pageNo - 1) * this.page.pageSize,
                maxResultCount: this.page.pageSize,
                ...this.searchData,
            }
            this.tableLoading = true
            const res = await dataValidationReportService.getDocumentFileReport(params)
            this.tableLoading = false
            if (res && res.code === 0) {
                this.tableData = res.data
                this.page.total = res.totalCount
                setTimeout(() => {
                    $('.el-table__header').width($('.el-table__body').width())
                }, 500)
            }
        },
        updateStandardId(val) {
            this.standardId = val
            this.getTypeList()
            this.searchList()
        },
        async getTypeList() {
            const parameter = {
                standard_id: this.standardId,
                data_type: 1,
                approve_status: 1,
                info_type: 1, // 文档
                catecode: 'Document', // 文档
            }
            const res = await stdClassListService.getClassList(parameter)
            if (res && res.code === 0) {
                this.classTypeList = res.data
            }
        },
    },
    created() {
        this.getTypeList()
        this.searchList()
    }
}
</script>